import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from '@mui/material/CircularProgress';

export const LoadingState = () => (
  <Box
    // display="flex"
    // justifyContent="center"
    sx={{ width: 'inherit' }}
    // my={4}
  >
     <CircularProgress />
  </Box>
);
